import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Html } from "@react-three/drei";
import { match } from "ts-pattern";
import { useCabinetStore } from "../../../../context/StoreContext";
import { getDimensions } from "../../../../hooks/getDimensions";
import { type CompartmentType, type Side, canMergeWith } from "../../data/Compartment";

interface MergerProps {
	side: Side;
	compartment: CompartmentType;
}

export function Merger({ side, compartment }: MergerProps) {
	const { state, api, mergeCompartment } = useCabinetStore();

	const thickness = state.thickness / 1000;
	const dimensions = getDimensions(compartment);

	const xPosition = match(side)
		.with("left", () => dimensions.x - dimensions.width / 2 - thickness / 2)
		.with("right", () => dimensions.x + dimensions.width / 2 + thickness / 2)
		.otherwise(() => dimensions.x);

	const yPosition = match(side)
		.with("top", () => dimensions.y + dimensions.height / 2 + thickness / 2)
		.with("bottom", () => dimensions.y - dimensions.height / 2 - thickness / 2)
		.otherwise(() => dimensions.y);

	const compartmentToMergeWith = canMergeWith(compartment, side, state, api);

	if (!compartmentToMergeWith) {
		return null;
	}

	return (
		<Html center position={[xPosition, yPosition, dimensions.z + dimensions.depth / 2]}>
			<button
				type="button"
				className="flex h-5 w-5 items-center justify-center rounded-full bg-shades-light text-primary-dark shadow-sm transition hover:bg-shades-medium-light"
				aria-label="Vak samenvoegen"
				onClick={() => {
					mergeCompartment(compartment, side);
				}}
			>
				<FontAwesomeIcon className="h-4 w-4" icon={faTimes} />
			</button>
		</Html>
	);
}
